import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import ChartBrandingOption from 'charts/chart-branding-option'

/**
 * Chart Branding Modal
 * Separate modal for configuring chart branding/colors
 */
function ChartBrandingModal({
  show,
  onHide,
  onSave,
  chartTitle,
  brandingType: initialBrandingType,
  brandingColor: initialBrandingColor,
  municipalitySettings,
  isSaving = false
}) {
  const [brandingType, setBrandingType] = useState(initialBrandingType || '')
  const [brandingColor, setBrandingColor] = useState(initialBrandingColor || '')

  // Sync with props when modal opens or props change
  useEffect(() => {
    setBrandingType(initialBrandingType || '')
    setBrandingColor(initialBrandingColor || '')
  }, [initialBrandingType, initialBrandingColor, show])

  const handleSave = () => {
    onSave({
      branding_type: brandingType || null,
      branding_color: brandingColor || null
    })
  }

  const handleCancel = () => {
    // Reset to initial values
    setBrandingType(initialBrandingType || '')
    setBrandingColor(initialBrandingColor || '')
    onHide()
  }

  return (
    <Modal show={show} onHide={handleCancel} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          Chart Colors - {chartTitle || 'Untitled Chart'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted mb-4">
          Configure how your organization's brand colors are applied to this chart.
        </p>

        <ChartBrandingOption
          Form={Form}
          brandingType={brandingType}
          setBrandingType={setBrandingType}
          brandingColor={brandingColor}
          setBrandingColor={setBrandingColor}
          municipalitySettings={municipalitySettings}
        />

        {!municipalitySettings?.color_1 && (
          <div className="alert alert-info">
            <strong>No brand colors configured.</strong>
            <br />
            Go to Settings → Branding to configure your organization's brand colors.
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light-primary" onClick={handleCancel}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSave} disabled={isSaving}>
          {isSaving ? 'Saving...' : 'Save Colors'}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

ChartBrandingModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  chartTitle: PropTypes.string,
  brandingType: PropTypes.string,
  brandingColor: PropTypes.string,
  municipalitySettings: PropTypes.object,
  isSaving: PropTypes.bool
}

export default ChartBrandingModal
